/**
 * 価格計算システム - コアモジュール
 * @version 2.0.0
 * 
 * 責務:
 * - DynamicPriceCalculatorの初期化
 * - ProductOptionsManagerの初期化
 * - グローバル名前空間の管理
 */
(function() {
  'use strict';

  // グローバル名前空間の初期化
  window.PriceCalculator = window.PriceCalculator || {};

  /**
   * コアモジュール
   */
  const Core = {
    /**
     * 価格計算機を初期化
     * @returns {boolean} 初期化成功/失敗
     */
    initialize: function() {
      if (typeof DynamicPriceCalculator === 'undefined' || !window.productData) {
        console.warn('[Core] DynamicPriceCalculator not found or productData missing');
        return false;
      }

      try {
        // 既に初期化済みの場合はスキップ
        if (window.priceCalculator && window.productOptionsManager) {
          console.log('[Core] Already initialized, skipping');
          return true;
        }

        // デバッグ: 初期化前のデータ確認
        const priceData = window.productData.price_matrix?.price_data || [];
        const variationCodes = [...new Set(priceData.map(p => p.variation_code))];
        const printColorsInData = [...new Set(variationCodes.map(code => {
          const parts = code?.split('_') || [];
          return parts.length >= 2 ? parts.slice(1).join('_') : code;
        }))];
        console.log('[Core] Initializing with price_data:', {
          totalEntries: priceData.length,
          uniqueVariationCodes: variationCodes.length,
          printColorsInData: printColorsInData,
          hasRyomenColor: variationCodes.some(c => c && c.includes('両面カラー'))
        });

        // DynamicPriceCalculatorの初期化
        window.priceCalculator = new DynamicPriceCalculator(window.productData);

        // ProductOptionsManagerの初期化
        this.initializeOptionsManager();

        return true;
      } catch (error) {
        console.error('[Core] Error initializing:', error);
        return false;
      }
    },

    /**
     * オプションマネージャーを初期化
     */
    initializeOptionsManager: function() {
      if (typeof ProductOptionsManager === 'undefined' || !window.productData.product_options) {
        return;
      }

      if (!window.productOptionsManager) {
        window.productOptionsManager = new ProductOptionsManager(
          window.productData.product_options,
          window.priceCalculator
        );
        // 後方互換性のため、optionsManagerも設定
        window.optionsManager = window.productOptionsManager;
      } else {
        // priceCalculatorの参照を更新
        window.productOptionsManager.priceCalculator = window.priceCalculator;
      }
    },

    /**
     * エラー表示
     * @param {string} message - エラーメッセージ
     */
    showError: function(message) {
      const container = document.getElementById('price-table-container');
      if (container) {
        container.innerHTML = `<div class="price-table-loading"><p style="color: #d32f2f;">${message}</p></div>`;
      }
    }
  };

  // モジュールをエクスポート
  window.PriceCalculator.Core = Core;

})();

